import { browserCheck } from '@ta-interaktiv/browsercheck'
export const config = { isMobile: browserCheck.isMobile, chartHeight: 800 }
